export interface ContactRequestModel {
  SaleType: string;
  PropertyTypes: string[];
  FloorSize: number;
  FloorSizeUnits: number;
  ErfSize: number;
  ErfSizeUnits: number;
  BedRooms: number;
  Bathrooms: number;
  Garages: number;
  Parkings: number;
  PriceFrom: number;
  PriceTo: number;
  SelectedAreas: string[];
  Note: string;
}

export const defaultContactRequestModel: ContactRequestModel = {
  SaleType: "",
  PropertyTypes: [],
  FloorSize: 0,
  FloorSizeUnits: 0,
  ErfSize: 0,
  ErfSizeUnits: 0,
  BedRooms: 0,
  Bathrooms: 0,
  Garages: 0,
  Parkings: 0,
  PriceFrom: 0,
  PriceTo: 0,
  SelectedAreas: [], // empty array
  Note: "", // empty string
};
